import { PagedSearch } from '../../shared/model/paged-search.model';

export class ProfileBenefitSearchParams extends PagedSearch {
  public Keyword: string;
  public ProfileId: number;
  public MemebrshipLevelId: number;
  public ProfileStatus: string;
  public BenefitTypeId: number;
  public MembersEligibleForRenwal: boolean;
  public BillingAnchorMonth: number;
  public BillingRevenueItemNum: number;
  public DuesAmountMin: number;
  public DuesAmountMax: number;
  public UnpaidDuesAfter: Date;
  public AffCodes: string[];
  public IncludePrimaryRelationships: boolean;
  public MemberProfilesOnly: boolean;
  public ActiveOnly: boolean;
  public Active: boolean;

  public constructor() {
    super();

    this.Keyword = '';
    this.PageSize = 10;
    this.OrderBy = 'ReportName';
    this.ProfileId = 0;
    this.MemebrshipLevelId = 0;
    this.ProfileStatus = '0';
    this.BenefitTypeId = 0;
    this.MembersEligibleForRenwal = false;
    this.BillingAnchorMonth = 0;
    this.BillingRevenueItemNum = 0;
    this.AffCodes = [];
    this.IncludePrimaryRelationships = false;
    this.MemberProfilesOnly = false;
    this.ActiveOnly = true;
  }
}
